/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown> }} Plan_Warmup_RampInputs */

const en_us2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Warm-up sets on the first compound: ${i?.sets}`)
};

const pt_br2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries de aproximação no primeiro composto: ${i?.sets}`)
};

const es_419_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Series de aproximación en el primer compuesto: ${i?.sets}`)
};

const pt_pt2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries de aproximação no primeiro exercício composto: ${i?.sets}`)
};

const fr_fr2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries d'approche sur le premier polyarticulaire : ${i?.sets}`)
};

const de_de2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aufwärmsätze bei der ersten Grundübung: ${i?.sets}`)
};

const it_it2_plan_warmup_ramp = /** @type {(inputs: Plan_Warmup_RampInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie di avvicinamento sul primo multiarticolare: ${i?.sets}`)
};

/**
* | output |
* | --- |
* | "Warm-up sets on the first compound: {sets}" |
*
* @param {Plan_Warmup_RampInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_warmup_ramp = /** @type {((inputs: Plan_Warmup_RampInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Warmup_RampInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_warmup_ramp(inputs)
	if (locale === "es-419") return es_419_plan_warmup_ramp(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_warmup_ramp(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_warmup_ramp(inputs)
	if (locale === "de-DE") return de_de2_plan_warmup_ramp(inputs)
	if (locale === "it-IT") return it_it2_plan_warmup_ramp(inputs)
	return en_us2_plan_warmup_ramp(inputs)
});
export { plan_warmup_ramp as "plan.warmup_ramp" }